import React, {memo} from 'react'
import styles from "./FJFilterView.module.less";
import FJResourceHeader from "./FJResourceHeader";
import {FJCustomScroll} from "fj-components-common";
import FJCover from "./FJCover";
import FJLocalStore from "../../../store/FJLocalStore";
import FJButton from "fj-components/FJButton";
import FJFilterApply from "./FJFilterApply";

function FJFilterCommon(props) {
  const {active, onActiveChange, title, children, applyToAll, hasReset, onReset} = props;
  return (
    <div className={styles.box}>
      <FJResourceHeader onSwitchChange={onActiveChange}
                        filterActive={active}
                        title={title}
                        hasLine
                        hasSwitch/>
      <FJCustomScroll>
        <div className={styles.list}>{children}</div>
      </FJCustomScroll>
      <div className={styles.apply_box} style={{
        justifyContent: hasReset ? 'space-between' : 'center'
      }}>
        <FJFilterApply applyToAll={applyToAll} />
        {hasReset ? <FJButton textClass={styles.btn_text}
                              onClick={onReset}
                              className={styles.btn}
                              text={FJLocalStore._('reset')} /> : null}
      </div>
      {active ? null : <FJCover />}
    </div>
  );
}

export default memo(FJFilterCommon);